import { FC } from 'react';
import { Button, Col, Collapse, Divider, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import Page from '../../Components/Page/Page';
import BookyBox from '../../Components/Layout/BookyBox';
import { TextService } from '../../Services/TextService';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { useNavigate } from 'react-router-dom';

const PartnerSpiris = () => {
    const GetText = TextService.GetText;
    return <Page pageTitle={GetText("PageTitle_Spiris")}>
        <BookyBox>
            <Title>Integration till Spiris</Title>

            <Paragraph>OneFront 360 kan nu erbjuda en tidsbesparande integration till Spiris för företag och föreningar.<br /><br />
                Fakturor och betalningar som görs via Spiris kan läsas in till OneFront 360 och automatiserar t.ex. medlemsavprickning av årsavgift. Efter den första uppsättningen sker sedan kopplingen per automatik och information från Spiris läses in till OneFront.
                OneFront360 läser även in information om kunder och artiklar, och möjlliggör därmed en synkronisering av kundregister mellan Spiris och OneFront360.
                För att använda integrationen behöver du ha ett konto både hos OneFront 360 och Spiris, <a href={"/" + getCurrentLanguage() + "/Pricing"}>läs mer och skapa konto.</a>
            </Paragraph>
            <br /><br />
            <h2>Om Spiris</h2>
            <img
                alt="Spiris logotype"
                style={{ width: "400px", height: "auto", marginBottom: "20px" }}
                src={require('../../Images/spiris.png')}
            />
            <Paragraph>
                Att driva företag med Spiris (tidigare Visma Spcs) är enkelt. Spiris är den flexibla ekonomiplattformen. Allt finns samlat och automatiserat med smarta funktioner – från bokföring till fakturering och lön. Det ger dig tid till att fokusera på rätt saker. Det vill säga att starta, driva och utveckla din företagsdröm utan krånglig administration. Läs mer på <a target="_blank" href="https://www.spiris.se">spiris.se</a>
            </Paragraph>
        </BookyBox>
    </Page>
};

export default PartnerSpiris;